import { render, staticRenderFns } from "./SupplierImportedProductCsvFileColumnMapping.vue?vue&type=template&id=064e6932&scoped=true&"
import script from "./SupplierImportedProductCsvFileColumnMapping.vue?vue&type=script&lang=js&"
export * from "./SupplierImportedProductCsvFileColumnMapping.vue?vue&type=script&lang=js&"
import style0 from "./SupplierImportedProductCsvFileColumnMapping.vue?vue&type=style&index=0&id=064e6932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e6932",
  null
  
)

export default component.exports